<style scoped>
.title-dashboard {
  font-size: 1.25rem;
  font-weight: 400;
}

.menu-dashboard > a {
  color: #454d56;
  font-size: 1.25rem;
  font-weight: 400;
}

.menu-dashboard > a.active {
  color: #c3151c;
  font-weight: 600;
  border-bottom: 2px solid #c3151c;
}

.title-value {
  font-size: 1rem;
  font-weight: 600;
}

.value {
  font-size: 3rem;
  font-weight: 600;
}

.map {
  width: 100%;
  height: 80vh;
}
.ol-custom {
  z-index: 1000;
  top: 12em;
  left: 1.75em;
}
.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 280px;
}
.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}
.ol-popup-closer:after {
  content: "✖";
}
hr.divider-option {
  border-top: 1px solid #d6d8db;
}
</style>
<template>
  <b-container fluid>
    <b-card>
      <div class="mb-2">
        <BSelectWithValidation
          class="float-left mr-2"
          size="sm"
          v-model="wilayahId"
          rules="required"
          name="Provinsi"
        >
          <option :value="indo.id">
            {{ indo.name }}
          </option>
          <hr class="divider-option" />
          <option v-if="prov.id != null" :value="prov.id">
            {{ prov.name }}
          </option>
          <hr v-if="prov.id != null" class="divider-option" />
          <option v-if="kab.id != null" :value="kab.id">
            {{ kab.name }}
          </option>
          <hr v-if="kab.id != null" class="divider-option" />
          <option v-if="kec.id != null" :value="kec.id">
            {{ kec.name }}
          </option>
          <hr v-if="kec.id != null" class="divider-option" />
          <option
            v-for="item in wilayahs"
            :value="item.kode"
            v-bind:key="item.id"
          >
            {{ item.nama }}
          </option>
        </BSelectWithValidation>
        <BSelectWithValidation
          class="float-left mr-2"
          size="sm"
          v-model="classificationId"
          rules="required"
          name="Provinsi"
        >
          <option value="1">Jumlah Penduduk Menurut Jenis Kelamin</option>
        </BSelectWithValidation>
        <BSelectWithValidation
          class="float-left mr-2"
          size="sm"
          v-model="itemClassificationId"
          rules="required"
          name="Provinsi"
        >
          <option value="3">Laki-Laki + Perempuan</option>
          <option value="L">Laki-Laki</option>
          <option value="P">Perempuan</option>
        </BSelectWithValidation>
        <b-button
          @click="showIndicator()"
          class="float-left"
          variant="primary"
          size="sm"
        >
          <b-icon icon="display" aria-hidden="true"></b-icon>Tampilkan
        </b-button>
        <b-link to="#" class="float-right">Reset</b-link>
      </div>
      <div class="mb-2">
        <div id="map" class="map">
          <div class="ol-custom ol-unselectable ol-control">
            <button
              @click="resetZoom()"
              class="ol-zoom-in"
              type="button"
              title="Reset"
            >
              R
            </button>
          </div>
        </div>
        <div id="popup" class="ol-popup">
          <a href="#" id="popup-closer" class="ol-popup-closer"></a>
          <div id="popup-content"></div>
        </div>
      </div>
      <div class="mb-2">
        <b-row style="margin-top: 3.5rem">
          <b-col cols="4">
            <b-card>
              <span class="title-value">Jumlah Penduduk Indonesia</span>
              <p class="value">270.203.917</p>
              <span class="float-right">September, 2020</span>
            </b-card>
          </b-col>
          <b-col cols="8">
            <highcharts :options="chartOptions" id="chart"></highcharts>
          </b-col>
        </b-row>
      </div>
      <div class="mb-2">
        <b-row>
          <b-col>
            <span class="title-dashboard"
              >Jumlah Penduduk Menurut Provinsi</span
            >
            <b-table
              v-if="data != null"
              class="table-primary"
              bordered
              striped
              hover
              per-page="10"
              :current-page="currentPage"
              :items="
                data.filter(
                  (x) => x.first_classification_item_id == itemClassificationId
                )
              "
            ></b-table>
            <b-pagination
              v-model="currentPage"
              total-rows="34"
              per-page="10"
            ></b-pagination>
          </b-col>
          <b-col>
            <span class="title-dashboard">Piramida Penduduk Indonesia</span>
            <highcharts
              :options="pyramidOptions"
              id="chartPyramid"
            ></highcharts>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import indonesia from "../../../assets/data/indonesia.json";
import dataPenduduk from "../../../assets/data/sdpi/kab.json";
import config from "@/appConfig";
import WilayahService from "../../../services/WilayahService";
import BSelectWithValidation from "@/components/inputs/BSelectWithValidation";
import "ol/ol.css";
import GeoJSON from "ol/format/GeoJSON";
import Map from "ol/Map";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { OSM, Vector as VectorSource } from "ol/source";
import View from "ol/View";
import {
  OverviewMap,
  FullScreen,
  defaults as defaultControls,
} from "ol/control";
import { Fill, Stroke, Style } from "ol/style";
import Overlay from "ol/Overlay";
import Select from "ol/interaction/Select";
import { Chart } from "highcharts-vue";
export default {
  name: "HalamanAwal",
  components: {
    BSelectWithValidation,
    highcharts: Chart,
  },
  mounted() {
    this.provId = this.$route.params.prov;
    this.data = indonesia;
    this.data_penduduk = dataPenduduk
    this.getProvinsi();
    this.setMap(this.data_penduduk);
  },
  data: () => {
    return {
      currentPage: 1,
      fullscreen: false,
      mapOps: { map: null },
      vectorSourceOps: null,
      vectorLayerOps: null,
      style: null,
      extent: [],
      koordinat: [],
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },
        xAxis: {
          categories: [],
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Jumlah Penduduk (jiwa)",
            align: "high",
          },
          labels: {
            overflow: "justify",
          },
        },
        tooltip: {
          valueSuffix: " jiwa",
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        legend: {
          enabled: false,
          layout: "vertical",
          align: "right",
          verticalAlign: "top",
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor: "#FFFFFF",
          shadow: true,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Jumlah Penduduk",
            data: null,
          },
        ],
      },
      pyramidOptions: {
        chart: {
          type: "bar",
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },
        accessibility: {
          point: {
            valueDescriptionFormat: "{index}. Age {xDescription}, {value}%.",
          },
        },
        xAxis: [
          {
            categories: [
              "0-4",
              "5-9",
              "10-14",
              "15-19",
              "20-24",
              "25-29",
              "30-34",
              "35-39",
              "40-44",
              "45-49",
              "50-54",
              "55-59",
              "60-64",
              "65-69",
              "70-74",
              "75 + ",
            ],
            reversed: false,
            labels: {
              step: 1,
            },
            accessibility: {
              description: "Age (male)",
            },
          },
          {
            opposite: true,
            reversed: false,
            categories: [
              "0-4",
              "5-9",
              "10-14",
              "15-19",
              "20-24",
              "25-29",
              "30-34",
              "35-39",
              "40-44",
              "45-49",
              "50-54",
              "55-59",
              "60-64",
              "65-69",
              "70-74",
              "75 + ",
            ],
            linkedTo: 0,
            labels: {
              step: 1,
            },
            accessibility: {
              description: "Kelompok Umur (Perempuan)",
            },
          },
        ],
        yAxis: {
          title: {
            text: null,
          },
          labels: {
            formatter: function () {
              return Math.abs(this.value) + "";
            },
          },
          accessibility: {
            description: "Percentage population",
            rangeDescription: "Range: 0 to 5%",
          },
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          series: {
            stacking: "normal",
          },
        },
        series: [
          {
            name: "Laki-Laki",
            data: [
              -11293.7, -11295.3, -11449.8, -11495.7, -11632.2, -11410.8,
              -11109.1, -10556.7, -10014.6, -9025.6, -7872.4, -6546.3, -5091.7,
              -3681.5, -2179.1, -2007.5,
            ],
          },
          {
            name: "Perempuan",
            data: [
              10778.8, 10799.0, 10746.1, 10816.9, 11050.1, 10945.2, 10795.5,
              10354.3, 9928.5, 8996.9, 7874.0, 6574.5, 5117.8, 3772.6, 2374.9,
              2617.0,
            ],
          },
        ],
      },
      indo: {
        id: "00",
        name: "INDONESIA",
      },
      prov: {
        id: null,
        name: null,
      },
      kab: {
        id: null,
        name: null,
      },
      kec: {
        id: null,
        name: null,
      },
      wilayahId: "00",
      wilayahs: [],
      classificationId: "1",
      itemClassificationId: "3",
      data: null,
      provId: null,
    };
  },
  methods: {
    async getProvinsi() {
      await WilayahService.getRegions("?region_level=1").then(
        (result) => {
          this.wilayahs = result.data.data;
          this.wilayahId = this.provId;
          this.setCategory(
            this.data.filter(
              (x) => x.first_classification_item_id == this.itemClassificationId
            )
          );
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKabupaten() {
      await WilayahService.getRegions(
        "?region_level=2&region_code=" + this.wilayahId
      ).then(
        (result) => {
          this.wilayahs = result.data.data;
          this.setCategory(
            this.data.filter(
              (x) => x.first_classification_item_id == this.itemClassificationId
            )
          );
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKecamatan() {
      await WilayahService.getRegions(
        "?region_level=3&region_code=" + this.wilayahId
      ).then(
        (result) => {
          this.wilayahs = result.data.data;
          this.setCategory(
            this.data.filter(
              (x) => x.first_classification_item_id == this.itemClassificationId
            )
          );
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getDesa() {
      await WilayahService.getRegions(
        "?region_level=4&region_code=" + this.wilayahId
      ).then(
        (result) => {
          this.wilayahs = result.data.data;
          this.setCategory(
            this.data.filter(
              (x) => x.first_classification_item_id == this.itemClassificationId
            )
          );
        },

        (error) => {
          console.log(error);
        }
      );
    },
    setMap(data) {
      let geojson =
        config.GEOSERVER_API_URL +
        "/geoserver/indah-map/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=indah-map%3Akab&&CQL_FILTER=idprov%3D" +
        this.provId+
        "&outputFormat=application%2Fjson";
      let container = document.getElementById("popup");
      let content = document.getElementById("popup-content");
      let closer = document.getElementById("popup-closer");

      let overlay = new Overlay({
        element: container,
        autoPan: true,
        autoPanAnimation: {
          duration: 250,
        },
      });

      closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };

      let vectorSource = new VectorSource({
        url: geojson,
        format: new GeoJSON(),
      });

      this.vectorSourceOps = vectorSource;
      let style = [
        new Style({
          stroke: new Stroke({
            color: "#34495e",
            width: 0.25,
          }),
          fill: new Fill({
            color: "rgba(46, 204, 113,1)",
          }),
        }),
        new Style({
          stroke: new Stroke({
            color: "#34495e",
            width: 0.25,
          }),
          fill: new Fill({
            color: "rgba(241, 196, 15,1.0)",
          }),
        }),
        new Style({
          stroke: new Stroke({
            color: "#34495e",
            width: 0.25,
          }),
          fill: new Fill({
            color: "rgba(231, 76, 60,1.0)",
          }),
        }),
      ];
      this.style = style;
      let vectorLayer = new VectorLayer({
        projection: "EPSG:4326",
        source: this.vectorSourceOps,
        style: style,
      });

      this.vectorLayerOps = vectorLayer;
      vectorLayer.getSource().on("addfeature", function (event) {
        var feature = event.feature;
        feature.setStyle(style[Math.floor(Math.random() * 3)]);
        feature.set(
          "jmlPenduduk",
          data[feature.get("idkab")]
        );
      });

      let view = new View({
        projection: "EPSG:4326",
        center: [0, 0],
        zoom: 2,
      });

      let overviewMapControl = new OverviewMap({
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
      });

      let map = new Map({
        controls: defaultControls().extend([
          overviewMapControl,
          new FullScreen(),
        ]),
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
          this.vectorLayerOps,
        ],
        overlays: [overlay],
        target: "map",
        view: view,
      });
      this.mapOps.map = map;
      this.mapOps.vectorLayer = vectorLayer;
      vectorLayer.getSource().on("change", function (evt) {
        let source = evt.target;
        if (source.getState() === "ready") {
          map.getView().fit(source.getExtent(), map.getSize());
        }
      });
      let selectSingleClick = new Select();
      map.addInteraction(selectSingleClick);
      selectSingleClick.on("select", function (evt) {
        content.innerHTML =
          "<p>Jumlah Penduduk "+evt.selected[0].values_.nmkab+" :</p><code>" +
          evt.selected[0].values_.jmlPenduduk +
          "</code>";
        let featureCoords = evt.selected[0].getGeometry().getCoordinates();
        overlay.setPosition(featureCoords[0][0][0]);
      });

      // this.vectorSourceOps.setUrl(geoJsonDesa)
    },
    resetZoom() {
      this.mapOps.map
        .getView()
        .fit(
          this.mapOps.vectorLayer.getSource().getExtent(),
          this.mapOps.map.getSize()
        );
    },
    setCategory(data) {
      let i;
      this.chartOptions.xAxis.categories = [];
      this.chartOptions.series[0].data = [];
      for (i = 0; i < data.length; i++) {
        this.chartOptions.xAxis.categories.push(data[i].name);
        this.chartOptions.series[0].data.push(data[i].bps_value);
      }
    },
    showIndicator() {
      let id = this.wilayahId;
      if (id == "00") {
        this.$router.push({ path: "/sdpi/dashboard-indicator" });
      } else if (id.length == 2) {
        this.$router.push({ path: "/sdpi/dashboard-indicator/" + id });
      } else if (id.length == 4) {
        this.$router.push({
          path:
            "/sdpi/dashboard-indicator/" +
            id.substring(0, 2) +
            "/" +
            id.substring(2, 4),
        });
      } else if (id.length == 7) {
        this.$router.push({
          path:
            "/sdpi/dashboard-indicator/" +
            id.substring(0, 2) +
            "/" +
            id.substring(2, 4) +
            "/" +
            id.substring(4, 7),
        });
      } else if (id.length == 10) {
        this.$router.push({
          path:
            "/sdpi/dashboard-indicator/" +
            id.substring(0, 2) +
            "/" +
            id.substring(2, 4) +
            "/" +
            id.substring(4, 7) +
            "/" +
            id.substring(7, 10),
        });
      }
    },
  },
  watch: {
    wilayahId(val) {
      if (val == "00") {
        this.prov = {
          id: null,
          name: null,
        };
        this.kab = {
          id: null,
          name: null,
        };
        this.kec = {
          id: null,
          name: null,
        };
        this.getProvinsi();
      } else if (val > 0 && val < 100) {
        if (val != this.prov.id) {
          this.prov.id = this.wilayahId;
          this.prov.name = this.wilayahs.filter(
            (x) => x.kode == this.wilayahId
          )[0].nama;
        }
        this.kab = {
          id: null,
          name: null,
        };
        this.kec = {
          id: null,
          name: null,
        };
        this.getKabupaten();
      } else if (val > 1000 && val < 10000) {
        if (val != this.kab.id) {
          this.kab.id = this.wilayahId;
          this.kab.name = this.wilayahs.filter(
            (x) => x.kode == this.wilayahId
          )[0].nama;
        }
        this.kec = {
          id: null,
          name: null,
        };
        this.getKecamatan();
      } else if (val > 10000 && val < 10000000) {
        if (val != this.kec.id) {
          this.kec.id = this.wilayahId;
          this.kec.name = this.wilayahs.filter(
            (x) => x.kode == this.wilayahId
          )[0].nama;
        }
        this.getDesa();
      }
    },
  },
};
</script>
